import { DomainEventType } from '../enums';

export interface DomainEvent {
  id: string;
  type: DomainEventType | string;
  payload: Record<string, unknown>;
  userId: string | null;
  timestamp: Date;
}

export interface AuditEvent {
  id: string;
  actorId: string;
  actionType: string;
  targetId: string | null;
  metadata: Record<string, unknown> | null;
  timestamp: Date;
}

export interface Permission {
  id: string;
  key: string;
  description: string | null;
}

export interface RolePermission {
  role: string;
  permissionKey: string;
}
